// LLM generated - Model Claude 4 Sonnet
import React from 'react';

import { ContestChatModalContext } from './ContestChatModalContext';
import { useContestContext } from '../../../context/ContestContext/ContestContext';
import ContestChatModal from './ContestChatModal';
import PostModal from './PostModal';
import ConfirmModal from './ConfirmModal';
import ReportModal from './ReportModal';
import DisableChatModal from './DisableChatModal';

export default function ContestChatModals() {
  const { modals, closeModal } = React.useContext(ContestChatModalContext);
  const { contest } = useContestContext();
  const contestId = contest?.id;

  return (
    <>
      {modals.map((modal, index) => {
        switch (modal.type) {
          case 'ContestChatModal':
            return (
              <ContestChatModal
                key={`${modal.type}-${contestId}`}
                isOpen
                onClose={() => closeModal()}
                toggleChatAction={modal.toggleChatAction}
              />
            );
          case 'PostModal':
            return (
              <PostModal
                key={`${modal.type}-${modal.messageId || index}`}
                {...modal}
                isOpen
                onClose={() => closeModal()}
              />
            );
          case 'ConfirmModal':
            return (
              <ConfirmModal
                key={`${modal.type}-${modal.variant || 'default'}-${Date.now()}`}
                {...modal}
                isOpen
                onClose={() => closeModal()}
              />
            );
          case 'ReportModal':
            return (
              <ReportModal
                key={`${modal.type}-${modal.contentId || Date.now()}`}
                {...modal}
                isOpen
                onClose={() => closeModal()}
              />
            );
          case 'DisableChatModal':
            return (
              <DisableChatModal
                key={modal.type}
                {...modal}
                isOpen
                onClose={() => closeModal()}
              />
            );
          default:
            return null;
        }
      })}
    </>
  );
}
